import { amplitudeInstance } from "@config/amplitude";
import { LegalEntity } from "hassibot/services_v2/common/types";

/**
 * Logged on a deliberate legal entity switch (navbar selector).
 */
export const eventLegalEntitySwitch = (
  previousLegalEntity: Pick<LegalEntity, "uuid" | "mode">,
  nextLegalEntity: Pick<LegalEntity, "uuid" | "mode">
): void => {
  amplitudeInstance.logEvent("ENTITY_SWITCH", {
    fromLegalEntityUuid: previousLegalEntity.uuid,
    fromLegalMode: previousLegalEntity.mode,
    toLegalEntityUuid: nextLegalEntity.uuid,
    toLegalMode: nextLegalEntity.mode,
    isCrossMode: previousLegalEntity.mode !== nextLegalEntity.mode,
  });
};
